export enum FrequencyType {
  Once = 1,
  Daily = 2,
  Weekly = 3,
  Monthly = 4,
  Yearly = 5
}

export enum Week {
  Sunday = 0,
  Monday = 1,
  Tuesday = 2,
  Wednesday = 3,
  Thursday = 4,
  Friday = 5,
  Saturday = 6
}
